import { FieldValues } from '@/constants'
import axios from 'axios'

export class PhotoSeasonApi {
  private m_instance: any

  public constructor() {
    this.m_instance = axios.create({
      // baseURL: 'https://api.prod.photos-presse.com/photo-season',
      baseURL: 'https://api.photos-presse.com/photo-season',
    })
  }

  public updateBaseUrl(baseUrl: string): void {
    console.log('updateBaseUrl')

    this.m_instance.defaults.baseURL = baseUrl
  }

  public updateAuthorization(token: string): void {
    console.log('updateAuthorization')

    this.m_instance.defaults.headers.common['Authorization'] = token
  }

  public async get(payload: Record<string, string>): Promise<JSON> {
    console.log('photo-season-api get', payload)

    return this.m_instance.post('/', payload)
  }
}
